__turbopack_context__.v({
  "arrowBtn": "styles-module__gWVgvW__arrowBtn",
  "arrowBtnDisabled": "styles-module__gWVgvW__arrowBtnDisabled",
  "arrowsWrap": "styles-module__gWVgvW__arrowsWrap",
  "carousel": "styles-module__gWVgvW__carousel",
  "carouselContainer": "styles-module__gWVgvW__carouselContainer",
  "carouselItem": "styles-module__gWVgvW__carouselItem",
  "itemsContainer": "styles-module__gWVgvW__itemsContainer",
  "mobile": "styles-module__gWVgvW__mobile",
});
